module.exports = __webpack_public_path__ + "6bda49971d79df255714bc37f47161fd.svg";